import { update_user_state } from "../state/user_state";
import { useSelector, useDispatch } from "react-redux";
import {useEffect, useCallback, useMemo} from "react";


const TOKEN_KEY_IN_STORE = 'auth_token'

export default function useAuthToken() {
  
  const dispatch = useDispatch();
  const auth_token_from_clobal = useSelector((state) => state.user_state.auth_token);

  const auth_token = useMemo(()=>{
    return auth_token_from_clobal ||
        localStorage.getItem(TOKEN_KEY_IN_STORE) ||
        sessionStorage.getItem(TOKEN_KEY_IN_STORE) || null
  }, [auth_token_from_clobal])

  const clearToken = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY_IN_STORE);
    sessionStorage.removeItem(TOKEN_KEY_IN_STORE);
    dispatch(update_user_state({
      user_data: null,
      auth_token: null,
    }))
  }, [dispatch])

  const saveToken = useCallback( (auth_token, remember) => {
    if (remember) {
      localStorage.setItem(TOKEN_KEY_IN_STORE, auth_token);
    } else {
      sessionStorage.setItem(TOKEN_KEY_IN_STORE, auth_token);
    }
    dispatch(update_user_state({auth_token:auth_token}));
  }, [dispatch]);

  return {
    saveToken,
    clearToken,
    auth_token,
  };
}
